import React from 'react';
import logo from './../assets/logo_small.png';

export default function Footer() {
  return (
    <footer className="text-gray-700 py-4">
      <div className="container mx-auto text-center">
        <p className="text-xs sm:text-sm mb-2">
          For more info check out our 
          <a href="/faqs" className="text-[#BE1F18]"> FAQs </a> section.
        </p>
        <p className="text-xs sm:text-sm flex items-center justify-center">
          <img src={logo} className="h-4 w-8 mr-2" alt="Logo" />
          PSBS All rights reserved.
        </p>
      </div>
    </footer>
  );
}
